import { render, staticRenderFns } from "./IseRecorder.vue?vue&type=template&id=4920e124&scoped=true"
import script from "./IseRecorder.vue?vue&type=script&lang=js"
export * from "./IseRecorder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4920e124",
  null
  
)

export default component.exports